import React, { useState, useEffect } from 'react';

import { AdminFormRow, AdminSelect } from 'shared-components';
import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import {
  showErrorToast,
  showSuccessToast,
} from 'shared-components/BaseToast/Toast';
import { setDefaultCampaign } from 'services/api/admin-campaigns';
import {
  getCampaignList,
  getDefaultCampaign,
  getDiff,
  getSuccessToastTitle,
  getErrorToastTitle,
} from './utils';

const DefaultCampaigns = ({ campaigns }) => {
  const initialState = {
    season: '',
    boost: '',
    edit: '',
    shop: '',
  };
  const [defaultCampaigns, setDefaultCampaigns] = useState(initialState);
  const [selectedCampaigns, setSelectedCampaigns] = useState(initialState);
  const [isModified, setIsModified] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const campaignList = getCampaignList(campaigns);
  const {
    season: seasonCampaigns,
    boost: boostCampaigns,
    edit: editCampaigns,
    shop: shopCampaigns,
  } = campaignList;
  const {
    season: defaultSeason,
    boost: defaultBoost,
    edit: defaultEdit,
    shop: defaultShop,
  } = defaultCampaigns;
  const { season, boost, edit, shop } = selectedCampaigns;

  const handleChangeCampaign = (e, type) => {
    const { value } = e.target;
    setSelectedCampaigns((prevState) => ({
      ...prevState,
      [type]: value,
    }));
  };
  const handleClickCancel = () => setSelectedCampaigns(defaultCampaigns);
  const handleClickSave = () => {
    setIsSaving(true);
    const diff = getDiff(
      season,
      boost,
      edit,
      shop,
      defaultSeason,
      defaultBoost,
      defaultEdit,
      defaultShop
    );
    Promise.all(diff.map((campaignId) => setDefaultCampaign(campaignId)))
      .then(() => {
        setIsModified(false);
        setDefaultCampaigns(selectedCampaigns);
        const toastTitle = getSuccessToastTitle(campaigns, diff);
        showSuccessToast(toastTitle);
      })
      .catch(() => {
        const toastTitle = getErrorToastTitle(campaigns, diff);
        showErrorToast(toastTitle);
      })
      .finally(() => setIsSaving(false));
  };

  useEffect(() => {
    if (campaigns.length) {
      const defaultSeasonCampaign = getDefaultCampaign(seasonCampaigns);
      const defaultBoostCampaign = getDefaultCampaign(boostCampaigns);
      const defaultEditCampaign = getDefaultCampaign(editCampaigns);
      const defaultShopCampaign = getDefaultCampaign(shopCampaigns);
      setDefaultCampaigns({
        season: defaultSeasonCampaign,
        boost: defaultBoostCampaign,
        edit: defaultEditCampaign,
        shop: defaultShopCampaign,
      });
      setSelectedCampaigns({
        season: defaultSeasonCampaign,
        boost: defaultBoostCampaign,
        edit: defaultEditCampaign,
        shop: defaultShopCampaign,
      });
    }
  }, [campaigns]);

  useEffect(() => {
    if (
      season !== defaultSeason ||
      boost !== defaultBoost ||
      edit !== defaultEdit ||
      shop !== defaultShop
    ) {
      setIsModified(true);
    } else {
      setIsModified(false);
    }
  }, [selectedCampaigns]);

  return (
    <div>
      <h4>Campaign Type Defaults</h4>
      <AdminFormRow>
        <AdminSelect
          name="add-ons"
          label="Default Add-Ons Campaign"
          list={seasonCampaigns}
          selected={season}
          selectLabel="Select a Campaign"
          handleChange={(e) => handleChangeCampaign(e, 'season')}
        />
        <AdminSelect
          name="boost"
          label="Default Boost Campaign"
          list={boostCampaigns}
          selected={boost}
          selectLabel="Select a Campaign"
          handleChange={(e) => handleChangeCampaign(e, 'boost')}
        />
        <AdminSelect
          name="edit"
          label="Default Edit Campaign"
          list={editCampaigns}
          selected={edit}
          selectLabel="Select a Campaign"
          handleChange={(e) => handleChangeCampaign(e, 'edit')}
        />
        <AdminSelect
          name="shop"
          label="Default Shop Campaign"
          list={shopCampaigns}
          selected={shop}
          selectLabel="Select a Campaign"
          handleChange={(e) => handleChangeCampaign(e, 'shop')}
        />
      </AdminFormRow>
      {isModified && (
        <AdminFormRow>
          <Button
            type="button"
            disabled={isSaving}
            onClick={handleClickSave}
            style={{ width: '120px' }}
            buttonType={BUTTON_TYPES.PRIMARY}
          >
            Save
          </Button>
          <Button
            type="button"
            onClick={handleClickCancel}
            buttonType={BUTTON_TYPES.CANCEL}
            style={{ width: '120px' }}
          >
            Cancel
          </Button>
        </AdminFormRow>
      )}
    </div>
  );
};

export default DefaultCampaigns;
